/* eslint-disable */
import Persister from '../../../utils/LocalStoragePersister';

const mutations = {
  setLeave(state, data) {
    state.leaveData = data;
    console.log(state.leaveData)
  }  
};

export default mutations;
